import { client } from './claims';

export type SubmissionState = 'pending' | 'sending' | 'accepted' | 'failed' | 'unknown';
export interface SubmissionError {
  code?: string;
  message?: string;
  fields?: string[];
  httpStatus?: number;
}
export interface FinalResponseClosure {
  state: SubmissionState;
  operationId?: string;
  reasonLabels?: string[];
  recipient?: string;
  submissionError?: SubmissionError | null;
}
export interface FinalResponseSelection {
  sourceTaskId: string;
  responseDate: string;
  reasonCodes: string[];
}
export interface FinalResponseOptions {
  reasons: { code: string; label: string }[];
  sources: { id: string; subject: string; received_date: string }[];
  closure: FinalResponseClosure | null;
}
export interface FinalResponsePreview {
  previewToken: string;
  recipient: string;
  text: string;
  html: string;
  attachmentName: string;
}
export interface FinalResponseResult {
  state: SubmissionState;
  closed: boolean;
  retryAllowed: boolean;
  operationId?: string;
  submissionError?: SubmissionError | null;
}
const url = (id: string) => `/ui/claims/${encodeURIComponent(id)}/final-response`;
export const getFinalResponseOptions = async (id: string): Promise<FinalResponseOptions> =>
  (await client.get<FinalResponseOptions>(url(id))).data;
export const previewFinalResponse = async (id: string, data: FinalResponseSelection): Promise<FinalResponsePreview> =>
  (await client.post<FinalResponsePreview>(`${url(id)}/preview`, data)).data;
export const confirmFinalResponse = async (id: string, data: FinalResponseSelection & { previewToken: string; confirmed: true }): Promise<FinalResponseResult> =>
  (await client.post<FinalResponseResult>(`${url(id)}/confirm`, data)).data;
export const retryFinalResponse = async (id: string): Promise<FinalResponseResult> =>
  (await client.post<FinalResponseResult>(`${url(id)}/retry`)).data;
